import AddTaskIcon from "@mui/icons-material/AddTask";

import { HashLink } from "react-router-hash-link";
import { useTranslation } from "react-i18next";
import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import Fade from "react-reveal/Fade";

const ExpWithPicLeft = ({ smallTitle, title, content, imgUrl, imgHeight }) => {
  const { t, i18n } = useTranslation();
  return (
    <Grid
      maxWidth="md"
      container
      sx={{
        width: 1,
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        py: 10,
        ml: "auto",
        mr: "auto",
      }}
    >
      <Grid
        item
        md={6}
        sm={12}
        xs={12}
        sx={{
          width: { md: "600px", sm: 1 / 2 },
          height: {
            md: "600px",
            sm: "300px",
            xs: "500px",
          },
          backgroundImage: `url("https://images.unsplash.com/photo-1495521821757-a1efb6729352?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1026&q=80")`,
          backgroundSize: { md: "cover", sm: "100% 100%", xs: "100% 100%" },
        }}
      ></Grid>
      <Grid
        item
        md={6}
        sm={12}
        xs={12}
        sx={{
          px: 4,
          py: { md: 6, sm: 10, xs: 10 },
          fontSize: "30px",
          backgroundColor: "#eef4f9",
          height: "600px",
          color: "#5f6566",
        }}
      >
        <Fade delay={300}>
          <Typography
            sx={{ fontSize: "22px", fontWeight: 800, color: "#102840" }}
          >
            {t("stain_proof")}
          </Typography>
        </Fade>
        <Fade delay={400}>
          <Typography
            sx={{
              lineHeight: "170%",
              fontSize: "17px",
            }}
          >
            <Box
              sx={{
                fontSize: "17px",
                pt: 3,
                lineHeight: "1.6em",
                fontWeight: "bold",
                color: "#153a5b",
              }}
            >
              {t("nano_coating")}
            </Box>
            <Box sx={{ fontSize: "14px" }}>
              {t("nano_coating_exp")}
              {/* <Box sx={{ color: "#153a5b", textDecoration: "underline" }}>
                Learn more
              </Box> */}
            </Box>
            <Box
              sx={{
                fontSize: "17px",
                pt: 3,
                lineHeight: "1.6em",
                fontWeight: "bold",
                color: "#153a5b",
              }}
            >
              {t("nano_coating_effect")}
            </Box>
            <Box sx={{ fontSize: "14px" }}>
              <Box sx={{ mt: 2 }}>
                <AddTaskIcon
                  sx={{ position: "relative", top: "+3px", fontSize: "17px" }}
                />
                &nbsp;&nbsp;{t("nano_coating_effect1")}
              </Box>
              <Box sx={{ pt: 1 }}>
                <AddTaskIcon
                  sx={{ position: "relative", top: "+3px", fontSize: "17px" }}
                />
                &nbsp;&nbsp;{t("nano_coating_effect2")}
              </Box>
              <Box sx={{ pt: 1 }}>
                <AddTaskIcon
                  sx={{ position: "relative", top: "+3px", fontSize: "17px" }}
                />
                &nbsp;&nbsp;{t("nano_coating_effect3")}
              </Box>
              <Box sx={{ pt: 1 }}>
                <AddTaskIcon
                  sx={{ position: "relative", top: "+3px", fontSize: "17px" }}
                />
                &nbsp;&nbsp;{t("nano_coating_effect4")}
              </Box>
              <Box sx={{ pt: 1 }}>
                <AddTaskIcon
                  sx={{ position: "relative", top: "+3px", fontSize: "17px" }}
                />
                &nbsp;&nbsp;{t("nano_coating_effect5")}
              </Box>
            </Box>
          </Typography>
        </Fade>
      </Grid>
    </Grid>
  );
};

export default ExpWithPicLeft;
